import {
    NinchatActionType,
    NinchatAssignOldestTranscriptAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatAckEvent} from 'api/types/events'

import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const assignOldestTranscript = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatAssignOldestTranscriptAction}`,
    async (arg: NinchatActionParams<NinchatAssignOldestTranscriptAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatAssignOldestTranscriptAction

        try {
            return await ninchatClient.send(params) as NinchatAckEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
